import React, { useRef, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import GridMode from './GridMode';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';
import { CardsReward_context } from './context';
import CarouselMode from './CarouselMode';

const CardsReward = (props) => {
  //props
  const { heading, text, rewards } = props?.fields;
  //params
  const { carouselMode } = props.params;
  const isCarousel = carouselMode === '1';
  //ref
  const layerRef = useRef();
  const gridExpander = useRef();
  const selectedItem = useRef();
  const swiperRef = useRef();
  //states
  const [selectedItemState, setSelectedItemState] = useState(selectedItem);
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  //boolean
  const shouldRenderDescription = true;
  const shouldRenderTitle = true;
  //shared object for context
  const sharedObject = {
    isCarousel,
    layerRef,
    gridExpander,
    setSelectedItemState,
    selectedItemIndex,
    setSelectedItemIndex,
  };
  //hide the layer
  const hideLayerAndCloseItem = () => {
    selectedItemState.current.classList.remove('open');
    gridExpander.current.style.height = '0px';
    setSelectedItemIndex(-1);
  };
  
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CardsReward" />;
  }
  return (
    <CardsReward_context.Provider value={sharedObject}>
      <div
        className={clsx('CardsReward-layer', selectedItemIndex !== -1 ? 'show' : '')}
        ref={layerRef}
        onClick={() => hideLayerAndCloseItem()}
        ></div>
      <div className={clsx('CardsRewardSection', 'add-margins', props?.params?.Styles)}>
        <div className="content">
          {(shouldRenderTitle || shouldRenderDescription) && (
            <div className="crgv-wrap">
              {shouldRenderTitle && (
                <div className="crgv-item-title">
                  <Text field={heading} />
                </div>
              )}
              {shouldRenderDescription && (
                <RichText className="crgv-item-description" field={text} />
              )}
            </div>
          )}
        </div>
        <div className="content">
          {isCarousel ? (
            <CarouselMode props={props} rewards={rewards} swiperRef={swiperRef} />
          ) : (
            <GridMode props={props} rewards={rewards} />
          )}
        </div>
      </div>
    </CardsReward_context.Provider>
  );
};

export default withTranslation()(CardsReward);
